import React from 'react'
import "../Styles/ProductsPage.css"
import Color from '../Components/Colors/Color';

const Header = (props) => {
    return(
      <div className='products-page-header-container'>
        <img src='/Images/products-page-bg-1.png' alt='product-header-img' className='products-header-img' />
        <img src='/Images/products-header-bg-small.png' alt='product-header-img' className='products-header-img-small' />
        <img src='/Images/Frame 229 (2).png' alt='product-header-img' className='products-header-img-micro' />
        <div className='products-header-container'><h2 className='products-page-header' style={{color: Color.thirdText}}>{props.name}</h2></div> 
      </div>
    )
}

export default Header;